import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { apisiseci } from "../../../api";
import { AttendanceLocalDepartment } from "../../../../@types/attendance-local-department";

export function useAttendanceLocalDepartmentDelete(id: AttendanceLocalDepartment["id"]) {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        AttendanceLocalDepartment,
        AxiosError<{ detail: string }>
    >({
        mutationKey: ["attendance-local", "department", "delete", id],
        mutationFn: async () => {
            return apisiseci.delete(`/cms/setor_unidade/${id}/`, {
                headers: { Authorization: `Bearer ${token}` },
            });
        },
        onSuccess: async () => {
            toast.success("Setor removido com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "department", "list"],
            });
        },
        onError: (error) => {
            console.log(error);
            toast.error(error.response?.data?.detail || "Algo deu errado, tente novamente!");
        },
    });

    return mutation;
}
